export const rulesInvoiceStatus = {
  CREATED: ['CASH_PAID'],
  CASH_PAID: ['CREATED'],
};

export const rulesAdminChangeInvoiceStatus = {
  FINANCIAL_ADMIN: ['CASH_PAID', 'CREATED'],
};
